<div>
  <canvas #chartCanvas></canvas>
</div>
